<template>
  <div id="plan" @keyup="$parent.storeAdmin">
    <div class="printhide">
      <message
        :contents="true"
        :brand="modelValue.beleggen.brand"
        ref="msg"
      />
      <div class="menubar">
        <button @click="message" v-if="
          $parent.client != Number($store.state.client) || $parent.role > 7
        ">
          <awesomeIcon icon="envelope" /> Bericht plaatsen
        </button>
        <button @click="planToggle = true"><awesomeIcon icon="eye" /> Plan bekijken</button>
        <button @click="noteToggle = true">
          <awesomeIcon icon="edit"/>
          {{intakeAdmin.publicNote != ''
            ? 'Plan notitie bekijken'
            : 'Plan notitie toevoegen'
          }}
        </button>
        <button
          v-if="$parent.status != 'Ondertekend'"
          @click="showToggle = !showToggle"
          style="float:right;"
        >
          <awesomeIcon icon="bars" /> Alle regels tonen
        </button>
        <button
          v-if="$parent.status == 'Geaccepteerd'"
          @click="$parent.returnIntake()"
          style="float:right"
        >
          <awesomeIcon icon="pen-nib" />Plan aanpassen
        </button>
        <button
          v-if="!$parent.redo && $parent.status == 'Geaccepteerd'"
          @click="$parent.signIntake"
        >
          <awesomeIcon icon="unlock" /> Contract is ondertekend (via post)
        </button>
      </div>
      <modalWindow
        v-if="noteToggle"
        @close="noteToggle=false;lockScroll('off');"
      >
        <div class="titlebar">Plan notitie</div>
        <div class="form-notice">
          Let op! Deze notitie is zichtbaar in het beleggingsplan voor de klant.
        </div>
        <form @submit.prevent class="inset">
          <textarea
            @change="update" @paste="update"
            v-model="intakeAdmin.publicNote"
            placeholder="Beleggingsplan notitie..."
            rows="8"
          ></textarea>
        </form>
      </modalWindow>
      <div class="card inset clearfix">

        <span class="setting">
          Startdatum intake
          {{ new Date(new Date($parent.created).setHours(1)).toLocaleDateString() }}
        </span>
        <h2 class="title">
          <awesomeIcon icon="file-signature" /> Beleggingsplan
        </h2>

          <!-- errors -->
          <div v-if="$parent.status == 'Bezig'" class="msg error">
            De vragenlijst is nog <b>niet ingeleverd</b>, het beleggingsplan kan niet worden
            goedgekeurd.
          </div>
          <div
            v-if="errorsPlan !== 0 && $parent.status == 'Ingeleverd'"
            class="msg error"
          >
            Nog <b>{{ errorsPlan }}</b> kwestie(s) voor het beleggingsplan kan worden goedgekeurd.
          </div>
          <!-- blocker notitie -->
          <div class="msg error" style="margin-bottom:20px; margin-top:2px;">
            <button
              @click="noteBlockerToggle = !noteBlockerToggle"
              class="no-padding"
              style="float:right;"
            >
              {{
                noteBlockerToggle
                  ? "Opslaan"
                  : intakeAdmin.overwrite
                  ? ""
                  : "Notitie"
              }}
              <awesomeIcon icon="edit" v-if="!noteBlockerToggle" />
              <awesomeIcon icon="chevron-up" v-if="noteBlockerToggle" />
            </button>
            <span
              v-if="!noteBlockerToggle && intakeAdmin.overwrite != ''"
              style="display:inline-block; max-width:95%;"
            >
              <b>Notitie: </b><br />{{ intakeAdmin.overwrite }}
            </span>
            <form
              @submit.prevent
              v-if="noteBlockerToggle"
            >
              <textarea
                @change="update" @paste="update"
                v-model="intakeAdmin.overwrite"
                placeholder="Notitie..."
                rows="4"
                style="margin-top:10px;"
                autofocus
              ></textarea>
            </form>
          </div>
          <!-- Administratie notittie -->
          <div class="msg" style="margin-bottom:20px; margin-top:2px;">
            <button
              @click="noteAdminToggle = !noteAdminToggle"
              class="no-padding"
              style="float:right;"
            >
              {{
                noteAdminToggle
                  ? "Opslaan"
                  : intakeAdmin.note
                  ? ""
                  : "Administratie notitie"
              }}
              <awesomeIcon icon="edit" v-if="!noteAdminToggle" />
              <awesomeIcon icon="chevron-up" v-if="noteAdminToggle" />
            </button>
            <span
              v-if="!noteAdminToggle && intakeAdmin.note != ''"
              style="display:inline-block; max-width:95%;"
            >
              {{ intakeAdmin.note }}
            </span>
            <form
              @submit.prevent
              v-if="noteAdminToggle"
            >
              <textarea
                @change="update" @paste="update"
                v-model="intakeAdmin.note"
                placeholder="Administratie notitie..."
                rows="4"
                style="margin-top:10px;"
                autofocus
              ></textarea>
            </form>
          </div>

          <template v-if="$parent.redo && newFiles.length > 0">
            <div class="subheader">
              Nieuwe bestanden
            </div>
            <check
              :val="newFiles.length == 0"
              :fallback="`${newFiles.length} nieuw(e) bestand(en) geupload.`"
              validtext="Geen nieuwe bestanden geupload."
              errorType="warning"
            />
            <div class="invalid" v-for="file in newFiles" :key="file.path">
              {{ file.path }}
            </div>
          </template>
          <!-- doel warnings (doelbeleggen) -->
          <div class="subheader">
            Doel
            <span @click="showToggle = !showToggle" class="showtoggle">
              <awesomeIcon :icon="showToggle ? 'chevron-down' : 'chevron-up'" />
            </span>
          </div>

          <check
            v-if="modelValue.beleggen.brand == 'Doelbeleggen'
              && ((intake.goalData.type == 'levensonderhoud' && intake.goalData.box == '1')
              || intake.goalData.type == 'gouden-handdruk-uitkerend'
              || intake.goalData.type == 'netto-lijfrente-uitkerend')
            "
            :val="offerSelected"
            fallback="Geen uitkeringsindicatie geselecteerd."
            validtext="Uitkeringsindicatie geselecteerd."
            errorType="showstopper"
            :errorKey="`ss-${$parent.id}-geen-offerte-geselecteerd`"
          />

          <check
            v-if="$parent.userExtraPorts.length > 0"
            :val="false"
            :fallback="`Heeft meerdere doelen (${$parent.userExtraPorts.join(', ')}).`"
            errorType="warning"
          />
          <check
            v-if="
              $parent.redo
              && intake.rekeningData.iban.replace(/\s/g, '').toUpperCase()
              != $parent.previousIntake.rekeningData.iban.replace(/\s/g, '').toUpperCase()
            "
            :val="$parent.value"
            validtext="IBAN gewijzigd, er is een nieuwe identificatiestorting gemaakt"
            fallback="IBAN gewijzigd, nog geen nieuwe identificatiestorting gemaakt"
            errorType="showstopper"
            :errorKey="`ss-${$parent.id}-iban-gewijzigd`"
          />
          <check
            v-if="checkIbanSame()"
            fallback="Vaste tegenrekening is hetzelfde als rekeningnummer van een overdracht met
              stakingswinst."
            errorType="showstopper"
            :errorKey="`ss-${$parent.id}-iban-vtr-hetzelfde`"
          />
          <check
            v-if="
              $parent.redo
              && intake.rekeningData.iban.replace(/\s/g, '').toUpperCase()
              != $parent.previousIntake.rekeningData.iban.replace(/\s/g, '').toUpperCase()
              && $parent.value > 0
            "
            :val="false"
            fallback="IBAN gewijzigd en storting binnen, meld bij BO voor controle!"
            errorType="showstopper"
            :errorKey="`ss-${$parent.id}-iban-gewijzigd-geen-controle`"
          />
          <check
            v-if="intake.persoonsData[0]"
            :val="!intake.persoonsData[0].sterfteDatum"
            validtext="Aanspreekpunt leeft."
            fallback="Aanspreekpunt is gestorven, benoem iemand anders tot U persoon."
            errorType="blocker"
            errorKey="b-aanspreekpunt-gestorven"
          />
          <check
            v-if="$parent.redo"
            :val="
              intake.goalData.pastPeriodExperience !== 'C'
              || (
                $parent.toSatProfile(intake.goalData.risk) !== 'DB2'
                && $parent.toSatProfile(intake.goalData.risk) !== 'DB1'
              )
            "
            fallback="
              Heeft een defensief profiel(A) en is niet comfortabel bij de waardeschommelingen van
              de afgelopen periode.
            "
            validtext="
              Voelt zich comfortabel bij (of heeft begrip voor) de waarde schommelingen van de
              afgelopen periode.
            "
            errorType="showstopper"
            errorKey="ss-oncomfortabel-waardeschommelingen"
          />
          <check
            :val="intake.goalData.confirmRisk !== 'No'"
            fallback="Niet bereid doelstelling niet te halen."
            validtext="Acceptatie doelstelling niet halen."
            errorType="blocker"
            errorKey="b-niet-bereid-doelstelling-niet-te-halen"
          />
          <check
            :val="intake.goalData.confirmRiskLoss !== 'No'"
            fallback="Geen acceptatie inlegverlies."
            validtext="Acceptatie inlegverlies."
            errorType="blocker"
            errorKey="b-geen-acceptatie-inlegverlies"
          />
          <check
            v-if="intake.goalData.type === 'levensonderhoud'
              && intake.goalData.box === '1'
              && (intake.goalData.risk === 'hoog'
                || intake.goalData.risk === 'zeer hoog'
                || intake.goalData.risk === 'extreem hoog')"
            :val="intake.goalData.confirmRiskPension !== 'No'"
            fallback="Geen elders inkomen om inkomensdalingen op te vangen."
            validtext="Heeft elders inkomen om inkomensdalingen op te vangen."
            errorType="blocker"
            errorKey="b-geen-elders-inkomen-om-inkomensdalingen-op-te-vangen"
          />
          <template v-if="intakeAdmin.beleggen.brand == 'Doelbeleggen'">
            <check
              :val="Number(intake.goalData.score) >= 40"
              :fallback="
                `Doel te moeilijk - Haalbaarheid onder de 40% (${formatPrice(
                  intake.goalData.score
                )}%).`
              "
              :validtext="
                `Doel is niet te moeilijk - Haalbaarheid boven de 40% (${formatPrice(
                  intake.goalData.score
                )}%).`
              "
              errorType="warning"
            />
            <check
              :val="Number(intake.goalData.score) !== 99.9"
              :fallback="
                `Doel te makkelijk - Haalbaarheid is 99,9% (${formatPrice(
                  intake.goalData.score
                )}%).`
              "
              :validtext="
                `Doel is niet te makkelijk - Haalbaarheid is niet 99,9% (${formatPrice(
                  intake.goalData.score
                )}%).`
              "
              errorType="warning"
            />
          </template>
          <check
            v-if="intakeAdmin.beleggen.brand !== 'Doelbeleggen'"
            :val="Number(intake.goalData.stepout) <= 80"
            :fallback="`Probleemwaarde boven de 80% (${intake.goalData.stepout}%).`"
            :validtext="`Probleemwaarde onder of gelijk aan 80% (${intake.goalData.stepout}%).`"
            errorType="blocker"
            errorKey="b-probleemwaarde-boven-80procent"
          />
          <check
            :val="intake.goalData.risk4 != 'zeer veel'"
            fallback="Grote problemen indien de doelstelling niet wordt gehaald."
            validtext="Geen problemen indien de doelstelling niet wordt gehaald."
            errorType="blocker"
            errorKey="b-grote-problemen-indien-doelstelling-niet-wordt-gehaald"
          />
          <check
            v-if="
              intake.goalData.type != 'levensonderhoud'
              && intake.goalData.type != 'gouden-handdruk-uitkerend'
              && intake.goalData.type != 'netto-lijfrente-uitkerend'
            "
            :val="
              Number(intake.goalData.vermogen) + Number($parent.portValue || 0) <
                Number(intake.goalData.doel)
            "
            :fallback="
              `Het startbedrag (€ ${formatPrice(
                Number(intake.goalData.vermogen) + Number($parent.portValue || 0),
                true
              )},-) is groter dan het doelbedrag (€ ${formatPrice(
                Number(intake.goalData.doel),
                true
              )},-).`
            "
            :validtext="
              `Het startbedrag (€ ${formatPrice(
                Number(intake.goalData.vermogen) + Number($parent.portValue || 0),
                true
              )},-) is kleiner dan het doelbedrag (€ ${formatPrice(
                Number(intake.goalData.doel),
                true
              )},-).`
            "
            errorType="showstopper"
            errorKey="ss-startbedrag-groter-doelbedrag"
          />
          <check
            v-if="
              (intake.goalData.type == 'levensonderhoud'
              || intake.goalData.type == 'gouden-handdruk-uitkerend'
              || intake.goalData.type == 'netto-lijfrente-uitkerend')
              && !$parent.redo
            "
            :val="Number(intake.goalData.vermogen) > Number(intake.goalData.doel)"
            :fallback="
              `Het startbedrag (€ ${formatPrice(
                Number(intake.goalData.vermogen),
                true
              )},-) is kleiner dan het doelbedrag (€ ${formatPrice(
                Number(intake.goalData.doel),
                true
              )},-).`
            "
            :validtext="
              `Het startbedrag (€ ${formatPrice(
                Number(intake.goalData.vermogen),
                true
              )},-) is groter dan het doelbedrag (€ ${formatPrice(
                Number(intake.goalData.doel),
                true
              )},-).`
            "
            errorType="showstopper"
            errorKey="ss-startbedrag-kleiner-doelbedrag"
          />

          <!-- doel warnings (oxby) -->
          <check
            v-if="intakeAdmin.beleggen.brand === 'OXBY' && intake.goalData.risk"
            :val="calculatedStepoutValue < calculatedRiskValue"
            :fallback="`Probleemwaarde is hoger dan de aangegeven waardeschommeling
            (P${calculatedStepoutValue} - W${calculatedRiskValue}).`"
            :validtext="`Probleemwaarde is lager dan de aangegeven waardeschommeling
            (P${calculatedStepoutValue} - W${calculatedRiskValue}).`"
            errorType="showstopper"
            errorKey="ss-probleem-hoger-waardeschommeling"
          />
          <check
            v-if="intakeAdmin.beleggen.brand === 'OXBY'"
            :val="calculateReturn < 6"
            :fallback="`Het rendement is groter dan 6% (${calculateReturn}%).`"
            :validtext="`Het rendement is kleiner dan 6% (${calculateReturn}%).`"
            errorType="warning"
          />

          <!-- bedrijf warnings -->
          <template v-if="intake.rekeningData.type == 'Bedrijfsrekening'">
            <div class="subheader">Bedrijf ({{ intake.bedrijfsData.bedrijfsnaam }})
              <span @click="showToggle = !showToggle" class="showtoggle">
                <awesomeIcon :icon="showToggle ? 'chevron-down' : 'chevron-up'" />
              </span>
            </div>
            <check
              :val="intake.bedrijfsData.land == 'Nederland'"
              :fallback="
                `Bedrijf is gevestigd buiten Nederland (${intake.bedrijfsData.land}).`
              "
              validtext="Bedrijf is gevestigd in Nederland"
              errorType="warning"
            />
            <check
              :val="intake.financeData.negatiefVermorgen != 'Yes'"
              fallback="Bedrijf heeft een negatief eigen vermogen."
              validtext="Bedrijf heeft geen een negatief eigen vermogen."
              errorType="showstopper"
              errorKey="ss-bedrijf-negatief-eigen-vermogen"
            />
            <check
              :val="intake.financeData.uitgeleend != 'Yes'"
              fallback="Het bedrijf heeft geld uitgeleend aan een privé persoon."
              validtext="Het bedrijf heeft geen geld uitgeleend aan een privé persoon."
              errorType="warning"
            />
            <check
              :val="intake.financeData.uitgeleendU != 'Yes'"
              fallback="Het bedrijf heeft geld geleend aan de contactpersoon."
              validtext="Het bedrijf heeft geen geld geleend aan de contactpersoon."
              errorType="warning"
            />
            <check
              :val="intake.financeData.jaarrekening != 'No'"
              fallback="Het bedrijf heeft geen recente jaarrekening."
              validtext="Het bedrijf heeft een recente jaarrekening."
              errorType="showstopper"
              errorKey="ss-bedrijf-geen-jaarrekening"
            />
            <check
              :val="intake.financeData.statutenInvest == 'Yes'"
              fallback="Beleggen met vermogen niet in statuten."
              validtext="Beleggen met vermogen staat in statuten."
              errorType="showstopper"
              errorKey="ss-bedrijf-geen-jaarrekening"
            />
          </template>

          <!-- profile options -->
          <div class="subheader">
            Profiel
            <span @click="showToggle = !showToggle" class="showtoggle">
              <awesomeIcon :icon="showToggle ? 'chevron-down' : 'chevron-up'" />
            </span>
          </div>
          <!-- totaalBezit -->
          <div
            v-if="intake.goalData.vermogen > 0"
            :class="[showToggle ? 'valid hide' : 'valid show']"
            style="color:#888;"
          >
            <span
              v-for="(persoon, index) in filter(
                filter(intake.persoonsData, financeFilter),
                deathFilter,
              )"
              :key="`${index}-profileoptions`"
            >
              <span v-if="persoon.spaarrekening === 'Yes'">
                + &euro;&nbsp;{{ formatPrice(Number(persoon.spaarrekeningBedrag), true) }},- persoon
                {{ index + 1 }} betaal- of spaarrekening 1.<br />
              </span>
              <span v-if="persoon.spaarrekening2 === 'Yes'">
                + &euro;&nbsp;{{ formatPrice(Number(persoon.spaarrekeningBedrag2), true) }},-
                persoon {{ index + 1 }} betaal- of spaarrekening 2.<br />
              </span>
              <span v-if="persoon.spaarrekening3 === 'Yes'">
                + &euro;&nbsp;{{ formatPrice(Number(persoon.spaarrekeningBedrag3), true) }},-
                persoon {{ index + 1 }} betaal- of spaarrekening 3.<br />
              </span>
              <span v-if="persoon.beleggingen === 'Yes'">
                + &euro;&nbsp;{{ formatPrice(Number(persoon.beleggingenBedrag), true) }},- persoon
                {{ index + 1 }} beleggingen 1.<br />
              </span>
              <span v-if="persoon.beleggingenMeer === 'Yes'">
                + &euro;&nbsp;{{ formatPrice(Number(persoon.beleggingenMeerBedrag), true) }},-
                persoon {{ index + 1 }} beleggingen 2.<br />
              </span>
              <span v-if="persoon.beleggingenNogMeer === 'Yes'">
                + &euro;&nbsp;{{ formatPrice(Number(persoon.beleggingenNogMeerBedrag), true) }},-
                persoon {{ index + 1 }} beleggingen 3.<br />
              </span>
              <span
                v-if=" persoon.onroerendgoed === 'Yes'">
                + &euro;&nbsp;{{
                  formatPrice(Number(persoon.onroerendgoedVrijeverkoopwaarde), true)
                }},- persoon {{ index + 1 }} vrije verkoopwaarde overige onroerendgoed.<br />
              </span>
              <span
                v-if=" persoon.eigenwoning === 'Yes'">
                + &euro;&nbsp;0,- persoon {{ index + 1 }} vrije verkoopwaarde eigen woning telt niet
                mee (Waarde &euro;
                {{ formatPrice(Number(persoon.eigenwoningVrijeverkoopwaarde), true) }},-).<br />
              </span>
            </span>
            <b>&euro;&nbsp;{{ formatPrice(Number(totalBezit), true) }},- overig bezit.</b>
          </div>
          <!-- showstopper: Sparen te groot deel van inkomen -->
          <check
            v-if="totalSparen > 0"
            :val="(Number(totalInkomenPerJaar) - (Number(totalLastenPerMaand) * 12))
              * 0.60 > totalSparen * 12 "
            :fallback="`Bedrag om te sparen(€ ${formatPrice(totalSparen * 12, true)},-)
              is hoger dan netto te besteden(€ ${formatPrice(
                (Number(totalInkomenPerJaar) - (Number(totalLastenPerMaand) * 12)) * 0.60,
                true,
              )},-).`"
            :validtext="`Bedrag om te sparen(€ ${formatPrice(totalSparen * 12, true)},-)
              is lager dan netto te besteden(€ ${formatPrice(
                (Number(totalInkomenPerJaar) - (Number(totalLastenPerMaand) * 12)) * 0.60,
                true,
              )},-).`"
            errorType="showstopper"
            errorKey="ss-bedrag-spare-hoger-netto-besteden"
          />
          <check
            :val="Number(startPercentage) < Number(rekenPercentage)"
            :fallback="
              `Startbedrag (€ ${formatPrice(
                Number(intake.goalData.vermogen) + Number($parent.portValue || 0),
                true
              )},-) is meer dan ${rekenPercentage}% van het overig bezit (€ ${formatPrice(
                Number(totalBezit),
                true
              )},-), namelijk ${startPercentage}%.`
            "
            :validtext="
              `Startbedrag (€ ${formatPrice(
                Number(intake.goalData.vermogen) + Number($parent.portValue || 0),
                true
              )},-) is minder dan ${rekenPercentage}% van het overig bezit (€ ${formatPrice(
                Number(totalBezit),
                true
              )},-), namelijk ${startPercentage}%.`
            "
            errorType="showstopper"
            errorKey="ss-startbedrag-meer-overige-bezit"
          />
          <!-- Warning voor jaar/reserveringsruimte boven 72550 -->
          <check
            v-if="
              ( intake.goalData.type === 'pensioen'
                || intake.goalData.type === 'netto-lijfrente-opbouwend'
              )
              && intake.goalData.box === '1'
            "
            :val="
              Number(intake.goalData.vermogen)
              - Number(sumBy(
                filter(intake.transferData.overdrachten, 'bedrag'),
                o => Number(o.bedrag),
              )) <= 72550
            "
            :fallback="`Huidige bedrag (€ ${
              formatPrice(
                Number(intake.goalData.vermogen)
                - Number(sumBy(
                  filter(intake.transferData.overdrachten, 'bedrag'),
                  o => Number(o.bedrag),
                )), true)
              }) is wellicht hoger dan het maximaal jaar/reserveringsruimte.`
            "
            :validtext="`Huidige bedrag aan jaar/reserveringsruimte: € ${
              formatPrice(
                Number(intake.goalData.vermogen)
                - Number(sumBy(
                  filter(intake.transferData.overdrachten, 'bedrag'),
                  o => Number(o.bedrag),
                )), true)
              }.`
            "
            errorType="warning"
          />
          <!-- totaalBezit end -->
          <template v-if="!hypotheekCheck">
            <check
              :val="Number(totalInkomenPerJaar * 4.5) >= Number(totalHypotheek)"
              :fallback="
                `Totale hypotheeklast (€ ${formatPrice(
                  Number(totalHypotheek),
                  true
                )},-) is meer dan (4.5 x € ${formatPrice(
                  Number(totalInkomenPerJaar),
                  true
                )},-) het gezamenlijk jaarinkomen (€ ${formatPrice(
                  Number(totalInkomenPerJaar * 4.5),
                  true
                )},-).`
              "
              :validtext="
                `Totale hypotheeklast (€ ${formatPrice(
                  Number(totalHypotheek),
                  true
                )},-) is minder dan 4.5 x € ${formatPrice(
                  Number(totalInkomenPerJaar),
                  true
                )},- het gezamenlijk jaarinkomen (€ ${formatPrice(
                  Number(totalInkomenPerJaar * 4.5),
                  true
                )},-).`
              "
              errorType="showstopper"
              errorKey="ss-totale-hypotheeklast-meer-dan-gezamenlijk-inkomen"
            />
            <check
              :val="Number(totalVrijeverkoopwaarde) >= Number(totalHypotheek)"
              :fallback="
                `Totale hypotheeklast (€ ${formatPrice(
                  Number(totalHypotheek),
                  true
                )},-) is groter dan de vrije verkoopwaarde (€ ${formatPrice(
                  Number(totalVrijeverkoopwaarde),
                  true
                )},-).`
              "
              :validtext="
                `Totale hypotheeklast (€ ${formatPrice(
                  Number(totalHypotheek),
                  true
                )},-) is kleiner dan de vrije verkoopwaarde (€ ${formatPrice(
                  Number(totalVrijeverkoopwaarde),
                  true
                )},-).`
              "
              errorType="showstopper"
              errorKey="ss-totale-hypotheeklast-groter-dan-vrije-verkoopwaarde"
            />
          </template>
          <check
            v-if="!$parent.redo"
            :val="
              intake.goalData.targetDate
                ? new Date(intake.goalData.targetDate).setFullYear(
                    new Date(intake.goalData.targetDate).getFullYear() - Number(looptijdLimit)
                  ) > new Date()
                : Number(intake.goalData.looptijd) > Number(looptijdLimit)
            "
            :fallback="`${intake.goalData.targetDate
              ? `Doeldatum (
                  ${intake.goalData.type},
                  ${new Date(intake.goalData.targetDate).toLocaleDateString()}
                )`
              : `Doel looptijd (${intake.goalData.type}, ${formatPrice(
                  Number(intake.goalData.looptijd),
                  true
                )} jaar)`} is minder dan de minimale ${looptijdLimit} jaar.`"
            :validtext="`${intake.goalData.targetDate
              ? `Doeldatum (
                  ${intake.goalData.type},
                  ${new Date(intake.goalData.targetDate).toLocaleDateString()}
                )`
              : `Doel looptijd (${intake.goalData.type}, ${formatPrice(
                  Number(intake.goalData.looptijd),
                  true
                )} jaar)`} is meer dan de minimale ${looptijdLimit} jaar.`"
            errorType="showstopper"
            errorKey="ss-doel-looptijd-minder-dan-limiet-looptijd"
          />
          <!-- totaalInkomen -->
          <div
            v-if="totalInkomenPerMaand > 0"
            :class="[showToggle ? 'valid hide' : 'valid show']"
            style="color:#888;"
          >
            <span
              v-for="(persoon, index) in filter(
                filter(intake.persoonsData, financeFilter),
                deathFilter,
              )"
              :key="`${index}-planrules1`"
            >
              <span v-if="persoon.jaarinkomen > 0">
                + &euro;&nbsp;{{ formatPrice(Number(persoon.jaarinkomen) / 12, true) }},- persoon
                {{ index + 1 }} inkomen per maand (&euro;&nbsp;{{
                  formatPrice(Number(persoon.jaarinkomen), true)
                }},- p/j).<br />
              </span>
              <span v-if="persoon.inkomenType == 'Pensioen' && persoon.pensioen > 0">
                + &euro;&nbsp;{{ formatPrice(Number(persoon.pensioen) / 12, true) }},- persoon
                {{ index + 1 }} pensioen per maand (&euro;&nbsp;{{
                  formatPrice(Number(persoon.pensioen), true)
                }},- p/j).<br />
              </span>
              <span
                v-if="
                  persoon.inkomenType == 'Pensioen'
                  && persoon.pensioenHeeftAanvullend == 'Yes'
                  && persoon.pensioenAanvullend > 0"
                >
                + &euro;&nbsp;{{ formatPrice(Number(persoon.pensioenAanvullend) / 12, true) }},-
                persoon {{ index + 1 }} aanuvllend pensioen per maand (&euro;&nbsp;{{
                  formatPrice(Number(persoon.pensioenAanvullend), true)
                }},- p/j).<br />
              </span>
              <span v-if="persoon.anderInkomenPerJaar > 0">
                + &euro;&nbsp;{{ formatPrice(Number(persoon.anderInkomenPerJaar) / 12, true) }},-
                persoon {{ index + 1 }} overig inkomen ({{ persoon.anderInkomenType === 'Anders'
                  ? persoon.anderInkomenTypeOmschrijving
                  : persoon.anderInkomenType }}) per maand
                (&euro;&nbsp;{{ formatPrice(Number(persoon.anderInkomenPerJaar), true) }},- p/j).
                <br />
              </span>
              <span v-if="persoon.onroerendgoedBedragPerJaar > 0">
                + &euro;&nbsp;{{ formatPrice(
                  Number(persoon.onroerendgoedBedragPerJaar) / 12, true
                ) }},-
                persoon {{ index + 1 }} onroerend goed inkomen per maand
                (&euro;&nbsp;{{ formatPrice(
                  Number(persoon.onroerendgoedBedragPerJaar), true
                ) }},- p/j) voor {{persoon.onroerendgoedObjecten}}
                {{persoon.onroerendgoedObjecten == '1' ? 'object' : 'objecten'}}.
                <br />
              </span>
            </span>
            <b
              >&euro;&nbsp;{{ formatPrice(totalInkomenPerMaand, true) }},- totaal maandelijks
              inkomen.</b
            ><br /><br />
            <span
              v-for="(persoon, index) in filter(
                filter(intake.persoonsData, financeFilter),
                deathFilter,
              )"
              :key="`${index}-planrules2`"
            >
              <!-- Hypotheek -->
              <span v-if="persoon.hypotheekEigenWoning == 'Yes'">
                - &euro;&nbsp;{{
                  formatPrice(
                    Number(
                      (persoon.hypotheekEigenWoningWaarde *
                        (persoon.hypotheekEigenWoningRente
                          ? Number(persoon.hypotheekEigenWoningRente / 100)
                          : 5)) /
                        100 /
                        12
                    ),
                    true
                  )
                }},- persoon {{ index + 1 }} Hypotheek 1 eigen woning per maand.<br />
              </span>
              <span v-if="persoon.hypotheekEigenWoning2 == 'Yes'">
                - &euro;&nbsp;{{
                  formatPrice(
                    Number(
                      (persoon.hypotheekEigenWoning2Waarde *
                        (persoon.hypotheekEigenWoning2Rente
                          ? Number(persoon.hypotheekEigenWoning2Rente / 100)
                          : 5)) /
                        100 /
                        12
                    ),
                    true
                  )
                }},- persoon {{ index + 1 }} Hypotheek 2 eigen woning per maand.<br />
              </span>
              <span v-if="persoon.hypotheekEigenWoning3 == 'Yes'">
                - &euro;&nbsp;{{
                  formatPrice(
                    Number(
                      (persoon.hypotheekEigenWoning3Waarde *
                        (persoon.hypotheekEigenWoning3Rente
                          ? Number(persoon.hypotheekEigenWoning3Rente / 100)
                          : 5)) /
                        100 /
                        12
                    ),
                    true
                  )
                }},- persoon {{ index + 1 }} Hypotheek 3 eigen woning per maand.<br />
              </span>

              <span v-if="persoon.hypotheekOnroerendGoed == 'Yes'">
                - &euro;&nbsp;{{
                  formatPrice(
                    Number(
                      (persoon.hypotheekOnroerendGoedWaarde *
                        (persoon.hypotheekOnroerendGoedRente
                          ? Number(persoon.hypotheekOnroerendGoedRente / 100)
                          : 5)) /
                        100 /
                        12
                    ),
                    true
                  )
                }},- persoon {{ index + 1 }} Hypotheek 1 overig onroerendgoed per maand.<br />
              </span>
              <span v-if="persoon.hypotheekOnroerend2Goed == 'Yes'">
                - &euro;&nbsp;{{
                  formatPrice(
                    Number(
                      (persoon.hypotheekOnroerendGoed2Waarde *
                        (persoon.hypotheekOnroerendGoed2Rente
                          ? Number(persoon.hypotheekOnroerendGoed2Rente / 100)
                          : 5)) /
                        100 /
                        12
                    ),
                    true
                  )
                }},- persoon {{ index + 1 }} Hypotheek 2 overig onroerendgoed per maand.<br />
              </span>
              <span v-if="persoon.hypotheekOnroerend3Goed == 'Yes'">
                - &euro;&nbsp;{{
                  formatPrice(
                    Number(
                      (persoon.hypotheekOnroerendGoed3Waarde *
                        (persoon.hypotheekOnroerendGoed3Rente
                          ? Number(persoon.hypotheekOnroerendGoed3Rente / 100)
                          : 5)) /
                        100 /
                        12
                    ),
                    true
                  )
                }},- persoon {{ index + 1 }} Hypotheek 3 overig onroerendgoed per maand.<br />
              </span>
              <!-- Overige lasten -->
              <span v-if="persoon.huurlasten > 0">
                - &euro;&nbsp;{{ persoon.huurlasten }},- persoon {{ index + 1 }} huurlasten per
                maand.<br />
              </span>
              <span v-if="persoon.schuldenMaandelijks > 0">
                - &euro;&nbsp;{{ persoon.schuldenMaandelijks }},- persoon {{ index + 1 }} lasten ({{
                  persoon.schuldenType
                }}) per maand.<br />
              </span>
              <span v-if="persoon.schuldenMeerMaandelijks > 0">
                - &euro;&nbsp;{{ persoon.schuldenMeerMaandelijks }},- persoon {{ index + 1 }} lasten
                ({{ persoon.schuldenMeerType }}) per maand.<br />
              </span>
              <span v-if="persoon.schuldenMeer2Maandelijks > 0">
                - &euro;&nbsp;{{ persoon.schuldenMeer2Maandelijks }},- persoon
                {{ index + 1 }} lasten ({{ persoon.schuldenMeer2Type }}) per maand.<br />
              </span>
              <span v-if="persoon.schuldenMeer3Maandelijks > 0">
                - &euro;&nbsp;{{ persoon.schuldenMeer3Maandelijks }},- persoon
                {{ index + 1 }} lasten ({{ persoon.schuldenMeer3Type }}) per maand.<br />
              </span>

            </span>
            <b
              >&euro;&nbsp;{{ formatPrice(totalLastenPerMaand, true) }},- totaal maandelijkse
              lasten.</b
            >
          </div>
          <!-- totaalInkomen end -->
          <check
            :val="(Number(totalLastenPerMaand) * 100) / Number(totalInkomenPerMaand) < 30"
            :fallback="
              `De maandelijkse lasten zijn groter dan 30% van het maandelijks inkomen (${parseFloat(
                (Number(totalLastenPerMaand) * 100) / Number(totalInkomenPerMaand)
              ).toFixed(2)}%).`
            "
            :validtext="`De maandelijkse lasten zijn kleiner dan 30% van het maandelijks inkomen
              (${formatPrice(
                (Number(totalLastenPerMaand) * 100) / Number(totalInkomenPerMaand) || 0,
                true
              )}%).`"
            errorType="showstopper"
            errorKey="ss-maandelijste-lasten-groter-30%-maandelijks-inkomen"
          />
          <check
            v-if="
              !$parent.redo
              && (
                (
                  intake.goalData.type === 'levensonderhoud'
                  && intake.goalData.box === '1'
                )
                || intake.goalData.type === 'gouden-handdruk-opbouwend'
                || intake.goalData.type === 'gouden-handdruk-uitkerend'
                || intake.goalData.type === 'netto-lijfrente-uitkerend'
              )"
            :val="checkTransferAmount"
            errorType="warning"
            :fallback="`Bedrag overdrachten is te ${transfersLowOrHigh} (
              € ${formatPrice(
                Number(sumBy(
                filter(intake.transferData.overdrachten, 'bedrag'),
                o => Number(o.bedrag),
                )), true)},- / € ${formatPrice(Number(intake.goalData.vermogen), true)},-
              ).`"
            validtext="Bedrag overdrachten is gelijk aan startvermogen."
          />
          <template v-if="intakeAdmin.beleggen.brand == 'Doelbeleggen'">
            <p class="msg" v-if="$parent.redo">
              Huidige maximale risico profiel: {{$parent.previousIntakeAdmin.beleggen.maxProfile}}
            </p>
            <check
              :val="intakeAdmin.beleggen.maxProfile"
              errorType="blocker"
              errorKey="b-geen-maximaal-profiel"
              fallback="Rekening heeft geen maximaal risico profiel."
              :validtext="`Maximaal Profiel ${intakeAdmin.beleggen.maxProfile}.`"
            />
            <div
              v-if="$parent.status == 'Bezig' || $parent.status == 'Ingeleverd'"
              class="row"
            >
              <customInput
                v-model="modelValue.beleggen.maxProfile"
                type="dropdown"
                :label="
                  `Maximale Risico Profiel (Suggestie ${$parent.fromSatProfile(profielKeuze)})`
                "
                :options="filter($parent.profileLabels, o => o.label.substr(0, 4) == 'Doel')"
                @changed="$parent.storeAdmin()"
              />
              <button
                v-if="modelValue.beleggen.maxProfile"
                @click="
                  modelValue.beleggen.maxProfile = null;
                  $parent.storeAdmin();
                  $parent.storeIntake(1);
                "
              >
                Maximale Profiel verwijderen
              </button>
              <button
                v-else
                @click="
                  modelValue.beleggen.maxProfile = $parent.fromSatProfile(profielKeuze);
                  $parent.storeAdmin();
                "
              >
                Kies Maximale Profiel suggestie
              </button>
              <check
                v-if="
                  $parent.redo
                  && $parent.previousIntakeAdmin.beleggen.maxProfile
                    !== modelValue.beleggen.maxProfile
                  && find($parent.users, (o) => {
                    return o.id === parseInt($parent.userOverview.send_client) && o.role > 7
                  })
                "
                :val="
                  $parent.previousIntakeAdmin.beleggen.maxProfile === modelValue.beleggen.maxProfile
                "
                errorType="showstopper"
                errorKey="ss-wijziging-maximale-profiel"
                fallback="Wijziging maximale profiel (niet door klant)"
              />

            </div>
            <span class="icon msg valid" v-else-if="modelValue.beleggen.maxProfile">
              <span class="icon">
                <awesomeIcon icon="check" />
              </span>
              Maximale risico profiel
              {{ modelValue.beleggen.maxProfile }}.
            </span>
            <check
              :val="
                !modelValue.beleggen.maxProfile ||
                  modelValue.beleggen.maxProfile === $parent.fromSatProfile(profielKeuze)
              "
              fallback="
                U heeft het suggestie maximale risico profiel aangepast, communiceer de nieuwe
                haalbaarheid met de klant.
              "
              validtext="U heeft het suggestie maximale risico profiel gekozen."
              errorType="warning"
            />
            <p class="msg" v-if="$parent.redo">
              Huidige risico profiel: {{$parent.previousIntakeAdmin.beleggen.profile}}
            </p>
            <check
              :val="intakeAdmin.beleggen.profile"
              errorType="blocker"
              errorKey="b-rekening-geen-start-profiel-db"
              fallback="Rekening heeft geen start profiel."
              :validtext="`Profiel ${intakeAdmin.beleggen.profile}.`"
            />
            <div
              v-if="$parent.status == 'Bezig' || $parent.status == 'Ingeleverd'"
              class="row"
            >
              <customInput
                v-model="modelValue.beleggen.profile"
                type="dropdown"
                :label="
                  `Start Profiel (Suggestie ${$parent.fromSatProfile(
                    intake.goalData.optimalProfile
                  )})`
                "
                :options="filter($parent.profileLabels, o => o.label.substr(0, 4) == 'Doel')"
                @changed="$parent.storeAdmin()"
              />
              <button
                v-if="modelValue.beleggen.profile"
                @click="
                  modelValue.beleggen.profile = null;
                  $parent.storeAdmin();
                  $parent.storeIntake(1);
                "
              >
                Start Profiel verwijderen
              </button>
              <button
                v-else
                @click="
                  modelValue.beleggen.profile = $parent.fromSatProfile(
                    intake.goalData.optimalProfile
                  );
                  $parent.storeAdmin();
                "
              >
                Kies Start Profiel suggestie
              </button>
            </div>
            <span class="icon msg valid" v-else-if="modelValue.beleggen.profile">
              <span class="icon">
                <awesomeIcon icon="check" />
              </span>
              Start profiel {{ modelValue.beleggen.profile }}.
            </span>
            <check
              v-if="modelValue.beleggen.profile && modelValue.beleggen.maxProfile"
              :val="intakeAdmin.beleggen.profile <= intakeAdmin.beleggen.maxProfile"
              fallback="Verlaag uw start profiel."
              validtext="Start profiel is niet hoger dan maximale profiel."
              errorType="showstopper"
              errorKey="ss-verlaag-start-profiel"
            />
            <check
              :val="
                !modelValue.beleggen.profile ||
                  modelValue.beleggen.profile ==
                    $parent.fromSatProfile(intake.goalData.optimalProfile)
              "
              fallback="U heeft niet het optimale start profiel gekozen."
              validtext="U heeft het suggestie start profiel gekozen."
              errorType="showstopper"
              errorKey="ss-niet-optimale-start-profiel"
            />
            <customInput
              v-model="modelValue.beleggen.lifecycleDisabled"
              type="yesno2"
              label="Lifecycle uitschakelen"
              @changed="$parent.storeAdmin"
              :confirm="
                modelValue.beleggen.lifecycleDisabled !== 'Yes'
                ? `Weet u zeker dat u lifecycle wilt uitschakelen?
                  Zo ja, motiveer dit dan in de showstopper`
                : `Weet u zeker dat u lifecycle wilt aanzetten?
                  Zo ja, motiveer dit dan in de administratie notitie.`
              "
              :validation="['notrequired']"
            />
            <check
              v-if="modelValue.beleggen.lifecycleDisabled"
              :val="modelValue.beleggen.lifecycleDisabled !== 'Yes'"
              fallback="Lifecycle uitgezet."
              validtext="Lifecycle staat aan."
              errorType="showstopper"
              errorKey="ss-lifecycle-uitgezet"
            />
          </template>
          <template v-else>
            <p class="msg" v-if="$parent.redo">
              Huidige maximale risico profiel: {{$parent.previousIntakeAdmin.beleggen.maxProfile}}
            </p>
            <check
              :val="intakeAdmin.beleggen.maxProfile"
              errorType="blocker"
              errorKey="b-rekening-geen-max-risico-profiel"
              fallback="Rekening heeft geen maximaal risico profiel."
              :validtext="`Maximaal Profiel ${intakeAdmin.beleggen.maxProfile}`"
            />
            <customInput
              v-if="$parent.status == 'Bezig' || $parent.status == 'Ingeleverd'"
              v-model="modelValue.beleggen.maxProfile"
              type="dropdown"
              :label="`Maximale Risico Profiel (Suggestie ${profielKeuzeGeneric})`"
              :options="filter($parent.profileLabels, o => o.label.substr(0, 4) == profileBrand)"
              @changed="$parent.storeAdmin"
            />
            <span v-else-if="modelValue.beleggen.maxProfile" class="icon msg valid">
              <span class="icon">
                <awesomeIcon icon="check" />
              </span>
              Maximale risico profiel {{ modelValue.beleggen.maxProfile }}.
            </span>
            <p class="msg" v-if="$parent.redo">
              Huidige risico profiel: {{$parent.previousIntakeAdmin.beleggen.profile}}
            </p>
            <check
              :val="intakeAdmin.beleggen.profile"
              errorType="blocker"
              errorKey="b-rekening-geen-start-profiel-andere-merken"
              fallback="Rekening heeft geen start profiel."
              :validtext="`Start Profiel ${intakeAdmin.beleggen.profile}`"
            />
            <customInput
              v-if="$parent.status == 'Bezig' || $parent.status == 'Ingeleverd'"
              v-model="modelValue.beleggen.profile"
              type="dropdown"
              :label="`Start Profiel`"
              :options="filter($parent.profileLabels, o => o.label.substr(0, 4) == profileBrand)"
              @changed="$parent.storeAdmin"
            />
            <span v-else-if="modelValue.beleggen.profile" class="icon msg valid">
              <span class="icon">
                <awesomeIcon icon="check" />
              </span>
              Start profiel {{ modelValue.beleggen.profile }}.
            </span>
          </template>
          <!-- plan fieldchecks -->
          <div class="subheader">
            Plan
            <span @click="showToggle = !showToggle" class="showtoggle">
              <awesomeIcon :icon="showToggle ? 'chevron-down' : 'chevron-up'" />
            </span>
          </div>
          <check
            v-if="!$parent.redo"
            :val="(JSON.parse(intakeAdmin.status).text == 'Adm. Rek. Open')"
            errorType="showstopper"
            errorKey="ss-client-status-niet-adm-rek-open"
            :fallback="`Client status: ${JSON.parse(intakeAdmin.status).text || 'nog geen status'}`"
            :validtext="`Client status: ${JSON.parse(intakeAdmin.status).text}`"
          />
          <check
            v-if="intakeAdmin.rekeningStatus !== 'Gesloten'"
            :val="intakeAdmin.cddStatus.text == 'CDD afgerond'"
            :errorType="$parent.redo ? 'warning' : 'blocker'"
            :errorKey="$parent.redo ? '' : 'b-cdd-niet-ingediend-en-of-afgerond'"
            :fallback="`CDD status: ${
              (intakeAdmin.cddStatus.handedText)
              ? 'CDD nog niet afgerond'
              : 'CDD nog niet ingediend'
            }`"
            :validtext="`CDD status: ${
              (intakeAdmin.cddStatus.text || intakeAdmin.cddStatus.handedText)
            }`"
          />
          <check
            v-if="!$parent.port"
            :val="$parent.port"
            errorType="blocker"
            errorKey="b-geen-portefeuillenummer"
            fallback="Geen portefeuillenummer."
          />
          <span v-else class="icon msg valid">
            <span class="icon">
              <awesomeIcon icon="check" />
            </span>
            Portefeuillenummer {{ $parent.port }}.
          </span>
          <check
            :val="intake.rekeningData.type"
            fallback="Geen rekeningtype."
            errorType="blocker"
            errorKey="b-geen-rekeningtype"
            :validtext="`Rekeningtype ${intake.rekeningData.type}.`"
          />
          <check
            v-if="$parent.redo"
            :val="new Date(intake.goalData.targetDate) > new Date()"
            fallback="Doeldatum in het verleden."
            errorType="warning"
            :validtext="
              `Doeldatum ${new Date(intake.goalData.targetDate).toLocaleDateString()}.`
            "
          />
          <check
            :val="intakeAdmin.beleggen.sales"
            errorType="warning"
            fallback="Rekening heeft geen adviseur."
            :validtext="`Adviseur ${intakeAdmin.beleggen.sales}.`"
          />
          <check
            :val="intakeAdmin.beleggen.manager"
            errorType="warning"
            fallback="Rekening heeft geen beheerder."
            :validtext="`Beheerder ${intakeAdmin.beleggen.manager}.`"
          />
          <check
            :val="!intakeAdmin.rekeningStatus"
            errorType="warning"
            :fallback="`Rekening is ${intakeAdmin.rekeningStatus}.`"
            validtext="Rekening is actief"
          />
          <check
            :val="
              (
                intakeAdmin.beleggen.brand === 'OXBY'
                || intakeAdmin.beleggen.brand === 'Doelbeleggen'
              )
                ? intakeAdmin.beleggen.report == '1'
                : intakeAdmin.beleggen.report == '3'
            "
            errorType="warning"
            :fallback="`Rapportage frequentie wijkt af voor ${intakeAdmin.beleggen.brand}:
            elke ${intakeAdmin.beleggen.report} maand(en).`"
            :validtext="`Rekening is standaard voor ${intakeAdmin.beleggen.brand}:
            elke ${intakeAdmin.beleggen.report} maand(en)`"
          />
          <check
            :val="checkDefaultFee"
            :fallback= "`Fee is niet standaard, namelijk ${currentFee}.`"
            :validtext="`Fee is standaard, namelijk ${currentFee}.`"
            errorType="showstopper"
            errorKey="ss-standaard-fee"
          />
          <div class="subheader">
            Duurzaamheid
            <span @click="showToggle = !showToggle" class="showtoggle">
              <awesomeIcon :icon="showToggle ? 'chevron-down' : 'chevron-up'" />
            </span>
          </div>
          <check
            :val="intake.rekeningData.sustainability !== 'A'"
            fallback="Wel duurzaamheidsvoorkeuren."
            validtext="Geen duurzaamheidsvoorkeuren."
            errorType="warning"
            :icon="true"
          />

          <div class="subheader">
            Risico beoordeling
            <span @click="showToggle = !showToggle" class="showtoggle">
              <awesomeIcon :icon="showToggle ? 'chevron-down' : 'chevron-up'" />
            </span>
          </div>
          <div
            class="msg"
            v-if="
              $parent.redo
              && intakeAdmin.cdd
              && intakeAdmin.cddStatus
              && intakeAdmin.cddStatus.date
            "
          >
            Laatste CDD datum: {{new Date(intakeAdmin.cddStatus.date).toLocaleDateString()}}
            <br />
            Volgende CDD controle over {{monthsTillNextCDD}} maanden
          </div>
          <check
            v-if="intakeAdmin.cdd
              && intakeAdmin.cdd['0-riskassesment']
              && intakeAdmin.cdd['0-riskassesment'].answer
              && intakeAdmin.cdd['0-riskassesment'].answer === 'Afgewezen'"
            :val="intakeAdmin.cdd['0-riskassesment'].answer !== 'Afgewezen'"
            errorType="blocker"
            errorKey="b-risico-beoordeling-afgewezen"
            fallback="Risico beoordeling: afgewezen"
          />
          <!-- cdd risico beoordeling datum check -->
          <check
            v-if="intakeAdmin.cdd
              && intakeAdmin.cddStatus
              && intakeAdmin.cddStatus.date
              && intakeAdmin.cdd['0-riskassesment']
              && intakeAdmin.cdd['0-riskassesment'].answer"
            :val="
              riskYearCheck(
                intakeAdmin.cdd['0-riskassesment'],
                intakeAdmin.cddStatus.date
              ) >= new Date()
            "
            errorType="warning"
            :fallback="`Risico (${intakeAdmin.cdd['0-riskassesment'].answer}
            - ${riskYear(intakeAdmin.cdd['0-riskassesment'])} jaar)
            beoordeling datum verlopen (${
              new Date(intakeAdmin.cddStatus.date).toLocaleDateString()
            })`"
            validtext="Risico beoordeling datum nog niet verlopen"
          />
          <!-- cdd risico beoordeling check -->
          <check
            v-else
            :val="intakeAdmin.cdd
              && intakeAdmin.cdd['0-riskassesment']
              && intakeAdmin.cdd['0-riskassesment'].state !== 'none'"
            errorType="warning"
            fallback="Risico beoordeling nog niet uitgevoerd"
            validtext="Risico beoordeling is uitgevoerd"
          />

          <!-- person warnings -->
          <span
            v-for="(persoon, index) in filter(intake.persoonsData, deathFilter)"
            :key="`r${index}persrules`"
          >
            <div class="subheader">
              Persoon {{ index + 1 }} ({{ persoon.voorletters }} {{ persoon.tussenvoegsel }}
              {{ persoon.achternaam }}) {{ persoon.type }}
              <span @click="showToggle = !showToggle" class="showtoggle">
                <awesomeIcon :icon="showToggle ? 'chevron-down' : 'chevron-up'" />
              </span>
            </div>
            <!-- Geen ervaring met beleggen, wel beleggingen -->
            <check
              v-if="intake.experienceData.ervaring == 'No' && persoon.beleggingen == 'Yes'"
              :val="persoon.beleggingen == 'No'"
              errorType="warning"
              fallback="Persoon heeft beleggingen, maar geeft aan geen ervaring hiermee te hebben"
            />
            <!-- Minderjarige en rol als rekeninghouder -->
            <check
              v-if="persoon.geboorteDatum && !calcAge(persoon.geboorteDatum, 18)"
              :val="persoon.type == 'Minderjarige'"
              errorType="blocker"
              errorKey="b-persoon-jonger-dan-18-rol-niet-minderjarig"
              fallback="Persoon is jonger dan 18, maar rol is niet minderjarig."
              validtext="Persoon is jonger dan 18 jaar en heeft als rol minderjarig."
            />
            <!-- Persoon heeft ander inkomen -->
            <check
              v-if="persoon.anderInkomen == 'Yes'"
              errorType="warning"
              :val="persoon.anderInkomenType !== 'Anders'"
              :fallback="`Heeft ander inkomen, namelijk ${persoon.anderInkomenTypeOmschrijving}.`"
              validtext="Heeft geen type inkomen anders."
            />
            <!-- geen woning en geen huur -->
            <check
              v-if="financeFilter(persoon) && persoon.zelfdeAdres !== 'Yes'"
              :val="!(persoon.eigenwoning === 'No' && persoon.huur === 'No')"
              errorType="warning"
              validtext="Heeft woning of huurlasten."
              :fallback="`Geen woning en geen huurlasten.
              ${persoon.geenWoningGeenHuurlasten
                ? `Reden: ${persoon.geenWoningGeenHuurlasten}`
                : 'Reden is nog onbekend. '}`"
            />
            <!-- Geen hypotheek op eigen woning en geen hypotheek op onroerend goed -->
            <check
              v-if="financeFilter(persoon) && intake.goalData.type == 'hypotheek'"
              :val="!(persoon.hypotheekEigenWoning === 'No'
                && persoon.hypotheekOnroerendGoed === 'No')"
              errorType="warning"
              validtext="Heeft woning of onroerend goed."
              fallback="
                Geen hypotheek op de eigen woning en geen hypotheek op onroerend goed, aflossen
                hypotheek niet mogelijk.
              "
            />
            <check
              v-if="
                financeFilter(persoon)
                && persoon.geboorteDatum
                && (
                  ($parent.intake.goalData.type == 'pensioen' && $parent.intake.goalData.box == '1')
                  || $parent.intake.goalData.type == 'netto-lijfrente-opbouwend'
                )
              "
              :val="calcOpbouw(persoon.geboorteDatum)"
              errorType="showstopper"
              :errorKey="`${index}-ss-uitkeringsdatum-boven-maximale-uitkeringsdatum`"
              :validtext="
                `Opbouw eindtijd (${
                  intake.goalData.targetDate
                  ? new Date(intake.goalData.targetDate).toLocaleDateString()
                  : new Date(calculateLooptijdAowAge).toLocaleDateString()
                }) ligt niet na einde jaar AOW leeftijd + 5 jaar
                (${calcAowAge(persoon.geboorteDatum).toLocaleDateString()}).`
              "
              :fallback="
                `Opbouw eindtijd (${
                  intake.goalData.targetDate
                  ? new Date(intake.goalData.targetDate).toLocaleDateString()
                  : new Date(calculateLooptijdAowAge).toLocaleDateString()
                }) ligt later dan einde jaar AOW leeftijd + 5 jaar
                (${calcAowAge(persoon.geboorteDatum).toLocaleDateString()}).`
              "
            />
            <check
              v-if="
                financeFilter(persoon)
                && persoon.geboorteDatum
                && $parent.intake.goalData.type == 'gouden-handdruk-opbouwend'
              "
              :val="calcOpbouw(persoon.geboorteDatum, 0)"
              errorType="showstopper"
              :errorKey="`${index}-ss-uitkeringsdatum-boven-maximale-uitkeringsdatum`"
              :validtext="
                `Opbouw eindtijd (${
                  intake.goalData.targetDate
                  ? new Date(intake.goalData.targetDate).toLocaleDateString()
                  : new Date(calculateLooptijdAowAge).toLocaleDateString()
                }) ligt niet na einde jaar AOW leeftijd
                (${calcAowAge(persoon.geboorteDatum, 0).toLocaleDateString()}).`
              "
              :fallback="
                `Opbouw eindtijd (${
                  intake.goalData.targetDate
                  ? new Date(intake.goalData.targetDate).toLocaleDateString()
                  : new Date(calculateLooptijdAowAge).toLocaleDateString()
                }) ligt later dan einde jaar AOW leeftijd
                (${calcAowAge(persoon.geboorteDatum, 0).toLocaleDateString()}).`
              "
            />
            <check
              v-if="financeFilter(persoon)"
              :val="persoon.insider !== 'Yes'"
              fallback="Aangewezen als 'insider'."
              validtext="Niet aangewezen als 'insider'."
              errorType="warning"
            />
            <!-- Inkomen (niet) genoeg vaste uitgaven patroon -->
            <check
              v-if="financeFilter(persoon)"
              :val="
                persoon.levensonderhoud !== 'nee, vanuit deze rekening'
                && (
                  goalType === 'uitkerend'
                  || persoon.levensonderhoud !== 'nee, vanuit andere rekening'
                )
              "
              fallback="
                Aangegeven dat het inkomen niet genoeg is voor levensonderhoud/vaste uitgavepatroon.
              "
              validtext="
                Aangegeven dat het inkomen genoeg is voor levensonderhoud/vaste uitgavepatroon.
              "
              errorType="showstopper"
              :errorKey="`${index}-ss-aangegeven-inkomen-niet-goed-genoeg-levensonderhoud`"
            />
            <template v-if="goalType === 'uitkerend'">
              <!-- Aanpassen manier van leven -->
              <check
                v-if="financeFilter(persoon) && persoon.levensonderhoud"
                :val="persoon.manierVanLeven === 'Yes'"
                fallback="Manier van leven kan niet aangepast worden."
                validtext="Manier van leven kan aangepast worden."
                errorType="showstopper"
                :errorKey="`${index}-ss-manier-van-leven-niet-aan-te-passen`"
              />
            </template>
            <!-- leeftijd minderjarige is lager dan 17 -->
            <check
              v-if="
                intake.rekeningData.type == 'Minderjarige rekening'
                && persoon.type == 'Minderjarige'
                && persoon.geboorteDatum
              "
              :val="!calcAge(persoon.geboorteDatum, 17)"
              errorType="warning"
              validtext="Minderjarige is jonger dan 17 jaar."
              fallback="Minderjarige Is 17 jaar of ouder"
            />
            <!-- leeftijd minderjarige is hoger dan 18 -->
            <check
              v-if="
                intake.rekeningData.type == 'Minderjarige rekening'
                && persoon.type == 'Minderjarige'
                && persoon.geboorteDatum
              "
              :val="!calcAge(persoon.geboorteDatum, 18)"
              errorType="showstopper"
              :errorKey="`${index}-ss-minderjarige-jonger-dan-18`"
              validtext="Minderjarige is jonger dan 18 jaar."
              fallback="Minderjarige is 18 jaar of ouder."
            />
            <check
              v-if="persoon.onroerendgoed === 'Yes'
                && persoon.onroerendgoedCommercieel === 'Yes'"
              errorType="warning"
              :val="Number(persoon.onroerendgoedBedragPerJaar) > 0"
              fallback="Het ingevoerde bedrag voor onroerend goed per jaar is € 0 euro."
              :validtext="`Het ingevoerde bedrag voor onroerend goed per jaar is
                € ${formatPrice(Number(persoon.onroerendgoedBedragPerJaar))},-.`"
            />
            <check
              v-if="financeFilter(persoon)"
              :val="persoon.belastingsplichtigBuitenland == 'No'"
              fallback="Belastingplichtig in het buitenland."
              validtext="Niet belastingplichtig in het buitenland."
              errorType="warning"
            />
            <check
              v-if="financeFilter(persoon) && persoon.inkomenType !== 'Pensioen'"
              :val="persoon.pensioenToereikend === 'Yes'"
              fallback="Verwachte pensioen is niet toereikend."
              validtext="Verwachte pensioen toereikend."
              errorType="warning"
            />
            <check
              v-if="persoon.eigenwoning == 'Yes'"
              :val="Number(persoon.eigenwoningVrijeverkoopwaarde) > 50000"
              fallback="Eigen woning verkoopwaarde van minder dan € 50.000,-."
              :validtext="
                `Eigen woning verkoopwaarde boven € 50.000,- (€ ${formatPrice(
                  Number(persoon.eigenwoningVrijeverkoopwaarde),
                  true
                )},-).`
              "
              errorType="warning"
            />
            <check
              v-if="financeFilter(persoon)"
              :val="persoon.inkomenType !== 'Uitkering'"
              fallback="Op dit moment een uitkering."
              validtext="Op dit moment geen uitkering."
              errorType="showstopper"
              :errorKey="`${index}-ss-uitkering`"
            />
            <check
              v-if="financeFilter(persoon)"
              :val="persoon.inkomenType !== 'Werkzoekende'"
              fallback="Op dit moment werkzoekende."
              validtext="Op dit moment niet werkzoekende."
              errorType="showstopper"
              :errorKey="`${index}-ss-werkzoekende`"
            />
            <check
              v-if="financeFilter(persoon)"
              :val="persoon.inkomenType !== 'Geen'"
              fallback="Op dit moment geen inkomen."
              validtext="Op dit moment inkomen."
              errorType="warning"
            />
            <!-- Heeft ander inkomen en verhuur(overig)-->
            <check
              v-if="financeFilter(persoon) && persoon.anderInkomen == 'Yes'"
              :val="persoon.anderInkomenType !== 'Verhuur'"
              fallback="Heeft ander inkomen uit verhuur (overig)."
              validtext="Heeft ander inkomen, maar niet uit verhuur (overig)."
              errorType="warning"
            />
            <!-- Belegt met een offensief profiel-->
            <check
              v-if="(totalSpaarBezit / totalBeleggingenBezit) * 100 < 50"
              :val="
                !(persoon.beleggingenProfiel === 'Offensief'
                || persoon.beleggingenMeerProfiel === 'Offensief'
                || persoon.beleggingenNogMeerProfiel === 'Offensief')
              "
              errorType="warning"
              validtext="Geen beleggingen van het type offensief"
              fallback="1 of meerdere beleggingen zijn van het type Offensief"
            />
            <!-- Hypotheek(alle) waarde is hoger dan de waarde van de eigen woning-->
            <check
              v-if="persoon.hypotheekEigenWoning == 'Yes' && persoon.eigenwoning == 'Yes'"
              :val="!(Number(totalHypotheekWoning) > Number(vrijeVerkoopwaarde))"
              :fallback="`De hypotheek (€ ${formatPrice(Number(totalHypotheekWoning), true)}) is
              hoger dan de waarde van de eigen woning
              (€ ${formatPrice(Number(vrijeVerkoopwaarde), true)}).`"
              :validtext="`Hypotheek (€ ${formatPrice(Number(totalHypotheekWoning), true)}) is
              niet hoger dan de waarde van de eigen woning
              (€ ${formatPrice(Number(vrijeVerkoopwaarde), true)}).`"
              errorType="warning"
            />

            <!-- Telefoonnummer 1 in incorrect of niet uit NL -->
            <check
              v-if="persoon.telefoonnummer || persoon.type !== 'Minderjarige'"
              :val="numberCheck(persoon.telefoonnummer)"
              :fallback="`Dit is geen NL telefoonnummer, controleer telefoonnummer (${
                persoon.telefoonnummer
              })`"
              validtext="Telefoonnummer is correct"
              errorType="warning"
            />

            <!-- Telefoonnummer 2 in incorrect of niet uit NL -->
            <check
              v-if="persoon.telefoonnummer2"
              :val="numberCheck(persoon.telefoonnummer2)"
              :fallback="`Dit is geen NL telefoonnummer, controleer telefoonnummer 2 (${
                persoon.telefoonnummer2
              })`"
              validtext="Telefoonnummer 2 is correct"
              errorType="warning"
            />
          </span>
          <div
            v-if="$parent.status == 'Ingeleverd'"
            class="subheader"
          >
            Afronden
          </div>
          <check
            v-if="
              $parent.redo
              && $parent.email != $parent.previousEmail
              && $parent.status == 'Ingeleverd'
              && $parent.previousId
            "
            :val="false"
            errorType="blocker"
            errorKey="b-intake-niet-op-juiste-gebruiker"
            :fallback="`
            De vragenlijst staat nog niet op dezelfde gebruiker als de vorige. Ga voor het
            afronden naar instellingen en koppel de juiste gebruiker. Er wordt geen email verstuurd.
            Huidige gebruiker '${$parent.email}' vs vorige '${
              $parent.previousEmail || 'verwijderde gebruiker'
            }'. Als u toch de nieuwe gebruiker wilt gebruiken kunt u de vorige afgeronde (her)
            intake eerst koppelen. De vorige (her) intake is te vinden onder nummer
            #${$parent.previousId}.
            `"
          />
          <button
            v-if="$parent.status == 'Ingeleverd'"
            @click="acceptPlan()"
            :class="[errorsPlan == 0 ? '' : 'disabled']"
            style="float:right; margin-top:20px;"
          >
            Plan goedkeuren <awesomeIcon icon="check" />
          </button>
          <button
            v-if="$parent.redo && $parent.status == 'Ingeleverd'"
            :class="[errorsPlan == 0 ? '' : 'disabled']"
            @click="errorsPlan == 0 ? $parent.completeIntake(false) : ''"
            style="float:right; margin-top:20px;margin-right:20px;"
          >
            Plan goedkeuren (zonder melding)
          </button>
      </div>

      <div class="card inset" v-if="!$parent.redo">
        <h2 class="title">
          <awesomeIcon icon="file-signature" /> Openen rekening
        </h2>
        <p>
          Startbedrag: &euro; {{ formatPrice(Number(intake.goalData.vermogen), true) }},-
        </p>
        <p>Tegenrekening: {{ intake.rekeningData.iban || "?" }}</p>
        <p>
          Gestorte waarde: &euro; {{ formatPrice($parent.value) }}
          <a class="secondary" @click="valueModal = true"><awesomeIcon icon="edit"/></a>
        </p>
        <p v-for="(transaction, index) in transactions" :key="index + 1">
          #{{ index + 1 }} ({{ new Date(transaction.date).toLocaleString() }}) - &euro;
          {{ formatPrice(transaction.amount) }} door {{ transaction.name }} van
          {{ transaction.iban }} (Status {{ toStatus(transaction) }})
        </p>
        <p v-if="positionsValue > 0">
          Portefeuille {{ $parent.port }} heeft voor &euro; {{ formatPrice(positionsValue) }} aan
          posities online staan.
          <table>
            <tr v-for="pos in positions" :key="pos.id">
              <td>{{ pos.name }}</td>
              <td class="number">&euro;&nbsp;{{ formatPrice(pos.worth) }}</td>
            </tr>
          </table>
        </p>
        <p v-else>Er staan nog geen posities voor portefeuille {{ $parent.port }} online.</p>
        <button
          v-if="$parent.status == 'Ondertekend' && $parent.port"
          @click="positionsValue > 0 && positions.length > 3 ? $parent.completeIntake() : ''"
          :class="[positionsValue > 0 && positions.length > 3 ? '' : 'disabled']"
          style="float:right; margin-top:20px;"
        >
          Rekening aanvragen <awesomeIcon icon="unlock" />
        </button>
        <span v-else-if="$parent.status != 'Afgerond'"
          >Om de rekening te openen en de vragenlijst af te ronden moet het beleggingsplan
          ondertekend zijn en de posities online staan.
        </span>
      </div>
      <div v-else class="card inset">
        <h2 class="title">
          <awesomeIcon icon="file-signature" /> Stortingen
        </h2>
        <p>Tegenrekening: {{ intake.rekeningData.iban || "?" }}</p>
        <p>
          Gestorte waarde: &euro; {{ formatPrice($parent.value) }}
          <a class="secondary" @click="valueModal = true"><awesomeIcon icon="edit"/></a>
        </p>
        <p v-for="(transaction, index) in transactions" :key="index + 1">
          #{{ index + 1 }} ({{ new Date(transaction.date).toLocaleString() }}) - &euro;
          {{ formatPrice(transaction.amount) }} door {{ transaction.name }} van
          {{ transaction.iban }} (Status {{ toStatus(transaction) }})
        </p>
      </div>
    </div>

    <modalWindow v-show="planToggle" @close="planToggle = false" width="860" position="edge">
      <div class="titlebar">Beleggingsplan</div>
      <div class="viewport">
        <plan
          v-if="intakeAdmin.beleggen.brand != 'Doelbeleggen'"
          :intake="intake"
          :intakeAdmin="intakeAdmin"
          :id="$parent.id"
          :redo="$parent.redo"
          :portValue="$parent.portValue"
          :today="$parent.completeDate"
        />
        <planDB
          v-if="intakeAdmin.beleggen.brand == 'Doelbeleggen'"
          :intake="intake"
          :intakeAdmin="intakeAdmin"
          :id="$parent.id"
          :redo="$parent.redo"
          :portValue="$parent.portValue"
          :today="$parent.completeDate"
        />
      </div>
      <div class="modalfooter">
        <span
          v-if="`${location}`.indexOf('http://') === -1 && `${location}`.indexOf('https://') === -1"
        >
          Printen is alleen mogelijk vanuit de site
        </span>
        <button style="float:right;" @click="windowPrint" v-else>
          Printen <awesomeIcon icon="print" />
        </button>
      </div>
    </modalWindow>

    <modalWindow v-show="valueModal" @close="valueModal=false;" width="400">
      <div class="titlebar">Waarde aanpassen</div>
      <form @submit.prevent class="inset">
        <input v-model="tempValue" placeholder="Intake waarde" />
        <button style="width:100%; margin-top:20px;" @click="updateValue()">
          Waarde aanpassen <awesomeIcon icon="check" />
        </button>
      </form>
    </modalWindow>
  </div>
</template>

<script>
/* eslint-disable */
import { filter, sumBy, find, some } from 'lodash-es';
import plan from "./plan";
import planDB from "./planDB";
import scoreWidget from "../ui/scoreMeter";
import check from "../ui/valueChecker";
import message from "../admin/message";

export default {
  name: 'IntakeAdminPlan',
  emits: ['update:model-value'],
  components: {
    scoreWidget,
    plan,
    planDB,
    check,
    message,
  },
  props: {
    modelValue: Object,
  },
  data() {
    return {
      location: window.location,
      showToggle: true,
      valueModal: false,
      tempValue: 0,
      planToggle: false,
      overruleToggle: false,
      noteToggle: false,
      noteAdminToggle: false,
      noteBlockerToggle: false,
      overruled: false,
      positionsValue: 0,
      positions: null,
      profileBrand: null,
      transactions: [],
      risks: [
        {
          name: "geen",
          show: true,
          up: 3.5,
          down: 0.5
        },
        {
          name: "zeer laag",
          show: this.$parent.intakeAdmin.beleggen.brand !== "OXBY",
          up: 15.0,
          down: -5.0
        },
        {
          name: this.$parent.intakeAdmin.beleggen.brand !== "OXBY" ? "laag" : "zeer laag",
          show: true,
          up: 21.5,
          down: -8.5
        },
        {
          name: "laag",
          show: this.$parent.intakeAdmin.beleggen.brand === "OXBY",
          up: 24.0,
          down: -11.0
        },
        {
          name: "gemiddeld",
          show: this.$parent.intakeAdmin.beleggen.brand !== "OXBY",
          up: 26.5,
          down: -12.0
        },
        {
          name: "gemiddeld",
          show: this.$parent.intakeAdmin.beleggen.brand === "OXBY",
          up: 30.5,
          down: -14.0
        },
        {
          name: "hoog",
          show: true,
          up: 35.5,
          down: -17.0
        },
        {
          name: "zeer hoog",
          show: this.$parent.intakeAdmin.beleggen.brand !== "OXBY",
          up: 38.0,
          down: -18.0
        },
        {
          name: this.$parent.intakeAdmin.beleggen.brand !== "OXBY" ? "extreem hoog" : "zeer hoog",
          show: true,
          up: 41.0,
          down: -19.0
        },
        {
          name: "extreem hoog",
          show: this.$parent.intakeAdmin.beleggen.brand === "OXBY",
          up: 51.0,
          down: -25.0
        }
      ]
    };
  },
  created() {
    this.tempValue = this.$parent.value;
    this.positionsValue = 0;
    if (this.$parent.port) {
      this.sdk.getPositions(this.$parent.port, null, response => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i += 1) {
            response.data[i].worth = response.data[i].quantity * response.data[i].rate;
            this.positionsValue += response.data[i].quantity * response.data[i].rate;
          }
          this.positions = response.data;
        }
      });
    }
    this.sdk.getIntakeTransactions(this.$parent.getQueryVariable("intake"), response => {
      if (response.status === 200) {
        this.transactions = response.data;
      }
    });
    // Convert profile brands to sort select list
    if (this.intakeAdmin.beleggen.brand == "OXBY") {
      this.profileBrand = "Oxby";
    } else if (this.intakeAdmin.beleggen.brand == "VMVB") {
      this.profileBrand = "V&M ";
    } else if (this.intakeAdmin.beleggen.brand == "BVS") {
      this.profileBrand = "BvS ";
    }
  },
  watch: {
    planToggle() {
      if (this.planToggle === true) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "initial";
      }
    }
  },
  computed: {
    currentFee() {
      const fee = find(
        this.$parent.feeoptions,
        (o) => o.value === this.intakeAdmin.beleggen.feeName
      );
      return fee ? fee.label : '?';
    },
    checkDefaultFee() {
      if (this.intakeAdmin.beleggen.brand === 'Doelbeleggen') {
        if (
          this.intake.atpData
          && this.intake.atpData.connected
          && (
            this.intakeAdmin.beleggen.feeName === 'dbatpopbouwend'
            || this.intakeAdmin.beleggen.feeName === 'dbatpuitkerend'
          )
        ) {
          return true;
        }
        return this.intakeAdmin.beleggen.feeName === 'db';
      }
      if (this.intakeAdmin.beleggen.brand === 'OXBY') {
        return this.intakeAdmin.beleggen.feeName === 'oxby';
      }
      return this.intakeAdmin.beleggen.feeName === 'vmbvs';
    },
    goalType() {
      if (
        (
          this.$parent.intake.goalData.type === 'levensonderhoud'
          && this.$parent.intake.goalData.box === '1'
        )
        || this.$parent.intake.goalData.type === 'netto-lijfrente-uitkerend'
        || this.$parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
      ) {
        return 'uitkerend';
      }
      return 'opbouwend';
    },
    monthsTillNextCDD() {
      const date = new Date();
      const riskYear = this.riskYearCheck(
        this.intakeAdmin.cdd['0-riskassesment'],
        this.intakeAdmin.cddStatus.date
      );
      let firstMonth = 0;
        if (riskYear > date) {
          let months;
          months = (riskYear.getFullYear() - date.getFullYear()) * 12;
          months -= date.getMonth();
          months += riskYear.getMonth();
          firstMonth = months <= 0 ? 0 : months;
        }
        return firstMonth;
    },
    offerSelected() {
      let selectedOffer = [];
      if (this.intake.goalData.type === 'netto-lijfrente-uitkerend') {
        selectedOffer = this.filter(
          this.intake.offers,
          (o) => (o.offerType === '4' || o.offerType === '5') && o.selected,
        );
      } else if (this.intake.goalData.type === 'gouden-handdruk-uitkerend') {
        selectedOffer = this.filter(
          this.intake.offers,
          (o) => (o.offerType === '2' || o.offerType === '3') && o.selected,
        );
      } else {
        selectedOffer = this.filter(
          this.intake.offers,
          (o) => (o.offerType === '0' || o.offerType === '1') && o.selected,
        );
      }
      if (selectedOffer[0]) {
        return Object.assign(
          selectedOffer[0],
          this.modelValue.offers[selectedOffer[0].offerId],
        );
      }
      return selectedOffer[0];
    },
    calculateLooptijdAowAge() {
      const d = new Date();
      return new Date(
        d.getFullYear() + Number(this.intake.goalData.looptijd),
        d.getMonth(),
        d.getDate(),
        12
      );
    },
    checkTransferAmount() {
      if (Number(this.intake.goalData.vermogen)
            - Number(sumBy(
              filter(this.intake.transferData.overdrachten, 'bedrag'),
              o => Number(o.bedrag),
            )) != 0)
      {
       return false;
      }
      return true;
    },
    transfersLowOrHigh() {
      if (Number(this.intake.goalData.vermogen)
          - Number(sumBy(
            filter(this.intake.transferData.overdrachten, 'bedrag'),
            o => Number(o.bedrag),
          )) > 0)
      {
       return 'laag';
      }
      return 'hoog';
    },
    newFiles() {
      const temp = [];
      for (let i = 0; i < this.$parent.files.length; i += 1) {
        const splitFiles = this.$parent.files[i].path.split('-');
        if (new Date(Number(splitFiles[1])) > new Date(this.$parent.created)) {
          temp.push(this.$parent.files[i]);
        }
      }
      return temp;
    },
    calculatedStepoutValue() {
      return Math.ceil(
        ((Number(this.intake.goalData.vermogen) + Number(this.$parent.portValue) || 0) /
          100) *
          parseInt(this.intake.goalData.stepout)
      );
    },
    calculatedRiskValue() {
      return Math.ceil(
        (Number(this.intake.goalData.vermogen) + Number(this.$parent.portValue)) *
          (this.risks.find(o => o.name === this.intake.goalData.risk).down / 100 + 1)
      );
    },
    errorsPlan() {
      return (
        Object.values(this.$store.state.showstoppersErrors).length
      );
    },
    intake() {
      return this.$parent.intake;
    },
    intakeAdmin() {
      return this.$parent.intakeAdmin;
    },
    totalSpaarBezit() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o =>
          // spaar
          Number(o.spaarrekeningBedrag || 0) +
          Number(o.spaarrekeningBedrag2 || 0) +
          Number(o.spaarrekeningBedrag3 || 0)
      );
    },
    totalBeleggingenBezit() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o =>
          // Beleggingen
          Number(o.beleggingenBedrag || 0) +
          Number(o.beleggingenMeerBedrag || 0) +
          Number(o.beleggingenNogMeerBedrag || 0)
      );
    },
    totalBezit() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o =>
          // spaar
          Number(o.spaarrekeningBedrag || 0) +
          Number(o.spaarrekeningBedrag2 || 0) +
          Number(o.spaarrekeningBedrag3 || 0) +
          // beleggingen
          Number(o.beleggingenBedrag || 0) +
          Number(o.beleggingenMeerBedrag || 0) +
          Number(o.beleggingenNogMeerBedrag || 0) +
          // verkoopwaarde eigenwoning niet mee rekenen!
          // verkoopwaarde onroerendgoed
          Number(o.onroerendgoedVrijeverkoopwaarde || 0)
      );
    },
    totalVrijeverkoopwaarde() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o =>
          // verkoopwaarde eigenwoning
          Number(o.eigenwoningVrijeverkoopwaarde || 0) +
          // verkoopwaarde onroerendgoed
          Number(o.onroerendgoedVrijeverkoopwaarde || 0)
      );
    },
    vrijeVerkoopwaarde() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o => Number(o.eigenwoningVrijeverkoopwaarde || 0)
      );
    },
    startPercentage() {
      return (
        ((Number(this.intake.goalData.vermogen) + Number(this.$parent.portValue || 0)) /
          Number(this.totalBezit)) *
        100
      ).toFixed(2);
    },
    totalSchulden() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o =>
          // hypotheek
          Number(o.hypotheekEigenWoningWaarde || 0) +
          Number(o.hypotheekEigenWoning2Waarde || 0) +
          Number(o.hypotheekEigenWoning3Waarde || 0) +
          // overige hypotheek
          Number(o.hypotheekOnroerendGoedWaarde || 0) +
          Number(o.hypotheekOnroerendGoed2Waarde || 0) +
          Number(o.hypotheekOnroerendGoed3Waarde || 0) +
          // overige schulden
          Number(o.schuldenBedrag || 0) +
          Number(o.schuldenMeerBedrag || 0) +
          Number(o.schuldenMeer2Bedrag || 0) +
          Number(o.schuldenMeer3Bedrag || 0)
      );
    },
    totalHypotheekWoning() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o =>
        // Hypotheek
          Number(o.hypotheekEigenWoningWaarde || 0) +
          Number(o.hypotheekEigenWoning2Waarde || 0) +
          Number(o.hypotheekEigenWoning3Waarde || 0)
      )
    },
    totalHypotheek() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o =>
          // hypotheek
          Number(o.hypotheekEigenWoningWaarde || 0) +
          Number(o.hypotheekEigenWoning2Waarde || 0) +
          Number(o.hypotheekEigenWoning3Waarde || 0) +
          // overige hypotheek
          Number(o.hypotheekOnroerendGoedWaarde || 0) +
          Number(o.hypotheekOnroerendGoed2Waarde || 0) +
          Number(o.hypotheekOnroerendGoed3Waarde || 0)
      );
    },
    totalInkomenPerMaand() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o =>
          Number(o.jaarinkomen / 12 || 0) +
          Number(o.anderInkomenPerJaar / 12 || 0) +
          Number(o.onroerendgoedBedragPerJaar / 12 || 0) +
          (o.inkomenType == "Pensioen" ? Number(o.pensioen / 12 || 0) : 0) +
          (o.inkomenType == "Pensioen" && o.pensioenHeeftAanvullend == 'Yes'? Number(o.pensioenAanvullend / 12 || 0) : 0)
      );
    },
    totalInkomenPerJaar() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o =>
          Number(o.jaarinkomen || 0) +
          Number(o.anderInkomenPerJaar || 0) +
          Number(o.onroerendgoedBedragPerJaar || 0) +
          (o.inkomenType == "Pensioen" ? Number(o.pensioen || 0) : 0) +
          (o.inkomenType == "Pensioen" && o.pensioenHeeftAanvullend == 'Yes'? Number(o.pensioenAanvullend || 0) : 0)
      );
    },
    totalLastenPerMaand() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o =>
          // hypotheek eigenwoning
          Number(
            (o.hypotheekEigenWoningWaarde *
              ((o.hypotheekEigenWoningRente ? Number(o.hypotheekEigenWoningRente / 100) : 5) /
                100)) /
              12 || 0
          ) +
          Number(
            (o.hypotheekEigenWoning2Waarde *
              ((o.hypotheekEigenWoning2Rente ? Number(o.hypotheekEigenWoning2Rente / 100) : 5) /
                100)) /
              12 || 0
          ) +
          Number(
            (o.hypotheekEigenWoning3Waarde *
              ((o.hypotheekEigenWoning3Rente ? Number(o.hypotheekEigenWoning3Rente / 100) : 5) /
                100)) /
              12 || 0
          ) +
          // hypotheek onroerendgoed
          Number(
            (o.hypotheekOnroerendGoedWaarde *
              ((o.hypotheekOnroerendGoedRente ? Number(o.hypotheekOnroerendGoedRente / 100) : 5) /
                100)) /
              12 || 0
          ) +
          Number(
            (o.hypotheekOnroerendGoed2Waarde *
              ((o.hypotheekOnroerendGoed2Rente ? Number(o.hypotheekOnroerend2GoedRente / 100) : 5) /
                100)) /
              12 || 0
          ) +
          Number(
            (o.hypotheekOnroerendGoed3Waarde *
              ((o.hypotheekOnroerendGoed3Rente ? Number(o.hypotheekOnroerend3GoedRente / 100) : 5) /
                100)) /
              12 || 0
          ) +
          // lasten
          Number(o.huurlasten || 0) +
          Number(o.schuldenMaandelijks || 0) +
          Number(o.schuldenMeerMaandelijks || 0) +
          Number(o.schuldenMeer2Maandelijks || 0) +
          Number(o.schuldenMeer3Maandelijks || 0)
      );
    },
    totalSparen() {
      return sumBy(
        filter(
          filter(this.intake.persoonsData, this.financeFilter),
          this.deathFilter,
        ),
        o =>
          o.levensonderhoud === 'ja, en kan sparen'
          && Number(o.kanSparenBedrag) > 0 ? Number(o.kanSparenBedrag) : 0
      );
    },
    profielKeuze() {
      let profile;
      if (this.intake.goalData.risk == "zeer laag") {
        profile = "DB2";
      } else if (this.intake.goalData.risk == "laag") {
        profile = "DB3";
      } else if (this.intake.goalData.risk == "gemiddeld") {
        profile = "DB4";
      } else if (this.intake.goalData.risk == "hoog") {
        profile = "DB5";
      } else if (this.intake.goalData.risk == "zeer hoog") {
        profile = "DB6";
      } else if (this.intake.goalData.risk == "extreem hoog") {
        profile = "DB6";
      } else {
        profile = "?";
      }
      return profile;
    },
    profielKeuzeGeneric() {
      let profile;
      if (this.intake.goalData.risk == "zeer laag") {
        profile = "Zeer defensief / Laag";
      } else if (this.intake.goalData.risk == "laag") {
        profile = "Defensief / Laag";
      } else if (this.intake.goalData.risk == "gemiddeld") {
        profile = "Neutraal / Midden";
      } else if (this.intake.goalData.risk == "hoog") {
        profile = "Offensief / Midden";
      } else if (this.intake.goalData.risk == "zeer hoog") {
        profile = "Zeer offensief / Hoog";
      } else if (this.intake.goalData.risk == "extreem hoog") {
        profile = "Zeer offensief / Hoog";
      } else {
        profile = "?";
      }
      return profile;
    },
    hypotheekCheck() {
      if (
        find(
          filter(
            filter(this.intake.persoonsData, this.financeFilter),
            this.deathFilter,
          ),
          o =>
            o.hypotheekEigenWoningType === "aflossingsvrij"
            && new Date(o.hypotheekEigenWoningLooptijd) <
              new Date().setYear(new Date().getFullYear() + 5)
        )
      ) {
        return false;
      } else {
        return true;
      }
    },
    rekenPercentage() {
      if (
        find(
          filter(
            filter(this.intake.persoonsData, this.financeFilter),
            this.deathFilter,
          ),
          function(o) {
            return o.inkomenType === "Loondienst" || o.inkomenType === "Pensioen";
          },
        )
      ) {
        return 125;
      } else {
        return 60;
      }
    },
    looptijdLimit() {
      if (this.intake.goalData.type == "pensioen") {
        return 5;
      } else {
        return 3;
      }
    },
    value() {
      return this.modelValue;
    },
    calculateReturn() {
      return (
        (Math.pow(
          Math.round(Number(this.intake.goalData.doel)) /
            (Math.round(Number(this.$parent.portValue || 0)) +
              Math.round(Number(this.intake.goalData.vermogen))),
          1 /
            this.remainingTimeInYears(new Date(this.intake.goalData.targetDate), new Date())
        ) -
          1) *
        100
      ).toFixed(2);
    }
  },
  methods: {
    filter,
    sumBy,
    find,
    numberCheck(number) {
      if (number) {
        const convertedNumber = number
          .replace(/[^\d\+]/g, '')
          .replace(/^\+/g, '00')
          .replace(/[^\d]/g, '')
          .replace(/^00/g, '+')
          .replace(/^0/g, '+31')
        ;
        if(convertedNumber.substring(0,3) !== '+31' || convertedNumber.length !== 12) {
          return false;
        }
        return true;
      }
      return false;
    },
    checkIbanSame() {
      return some(this.intake.transferData.overdrachten, (overdracht) => overdracht.overdrachtType === 'bv'
        && overdracht.kapitaalType === 'Stakingswinst'
        && overdracht.iban === this.intake.rekeningData.iban
        && Number(overdracht.bedrag) > 0);
    },
    calcOpbouw(birthdate, plusYears = 5) {
      if (this.intake.goalData.targetDate) {
        return new Date(this.intake.goalData.targetDate).setHours(12) <= this.calcAowAge(birthdate, plusYears);
      }
      return this.calculateLooptijdAowAge <= this.calcAowAge(birthdate, plusYears);
    },
    calcAge(birth, age) {
      if(birth && age) {
        const dateArray = birth.split('T')[0].split('-');
        const ageYear = new Date(
          Number(dateArray[0]) + Number(age),
          Number(dateArray[1]) - 1,
          Number(dateArray[2]),
        );
        return ageYear < new Date();
      }
      return false;
    },
    riskYear(risk) {
      let riskYears = null;
      if (risk.answer === 'Hoog risico') {
        riskYears = 1;
      } else if (risk.answer === 'Gemiddeld risico') {
        riskYears = 3;
      } else {
        riskYears = 5;
      }
      return riskYears;
    },
    riskYearCheck(risk, cddDate) {
      let riskYears = null;
      if (risk.answer === 'Hoog risico') {
        riskYears = 1;
      } else if (risk.answer === 'Gemiddeld risico') {
        riskYears = 3;
      } else {
        riskYears = 5;
      }
      const riskYearTotal = new Date(cddDate);
      riskYearTotal.setFullYear(riskYearTotal.getFullYear() + riskYears);
      return riskYearTotal;
    },
    message() {
      this.$refs.msg.userMessage(this.$parent.client, this.$parent.port
        ? `Bericht over portefeuille #${this.$parent.port}`
        : `Bericht over vragenlijst #${this.getQueryVariable('intake')}`
      );
    },
    lockScroll(toggle) {
      if (toggle === 'on') {
        document.body.classList.add('lock-scroll');
      } else {
        document.body.classList.remove('lock-scroll');
      }
    },
    remainingTimeInYears(endDate, fromDate) {
      const oneDay = 365 * 24 * 60 * 60 * 1000;
      return Math.abs((endDate - fromDate) / oneDay);
    },
    acceptPlan() {
      if (this.errorsPlan > 0) {
        this.$store.state.confirm.toggle({
          alert: true,
          text: `Nog ${this.errorsPlan} kwestie(s) voor het beleggingsplan kan worden goedgekeurd`,
          cb: () => {},
        });
      } else if (!this.$parent.redo && this.$parent.role < 10) {
        this.$store.state.confirm.toggle({
          alert: true,
          text: 'Je hebt niet de juiste bevoegdheden voor deze actie.',
          cb: () => {},
        });
      } else {
        // eslint-disable-next-line
        if (this.$parent.redo) {
          this.$parent.acceptIntake();
        } else {
          this.$store.state.confirm.toggle({
            text: 'Het plan goedkeuren verstuurt een e-mail naar de klant.',
            cb: (confirmed) => {
              if (confirmed) {
                this.$parent.acceptIntake();
              }
            },
          });
        }
      }
    },
    toStatus(log) {
      if (log.status === 1) {
        if (new Date() - new Date(log.date) > 1000 * 60 * 5) {
          return "Verlopen";
        }
        return "Bezig";
      } else if (log.status === 2) {
        return "Betaald";
      }
      return "Fout";
    },
    update() {
      this.$emit("update:model-value", this.value);
    },
    updateValue() {
      this.sdk.modifyIntakeValue(this.getQueryVariable("intake"), Number(this.tempValue), () => {
        window.onbeforeunload = () => {};
        window.location.reload();
      });
    },
    financeFilter(o) {
      if (
        this.intake.rekeningData.type == "Minderjarige rekening" &&
        o.type != "Minderjarige"
      ) {
        return true;
      } else if (
        this.intake.rekeningData.type == "Particuliere rekening" &&
        o.type != "Volmacht"
      ) {
        return true;
      } else if (
        this.intake.rekeningData.type == "Bedrijfsrekening" &&
        o.type != "Volmacht"
      ) {
        return true;
      }
      return false;
    },
    deathFilter(o) {
      return !o.sterfteDatum;
    },
  }
};
</script>

<style lang="scss" scoped>
.subheader {
  margin-top: 2px;
  margin-bottom: 2px;
  padding: 10px 20px;
  background-color: #e9ecf2;
  border-radius: 4px;
}
.hide {
  display: none !important;
}
.showtoggle {
  float: right;
  cursor: pointer;
}
.card {
  margin-top: 20px;
}
</style>
